var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportRankFirst(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2146_3394)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2146_3394",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H56V56H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2146_3394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3828 27.0462H32.5741L46.5653 0H35.3741L21.3828 27.0462Z",
    fill: "#006CA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3769 13.5234L22.7812 24.3428L24.1813 27.0466H32.5725L33.9725 24.3428L28.3769 13.5234Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4678 33.5775H22.2766V27.0456H33.4678V33.5775ZM33.4678 24.25H22.2766C21.534 24.25 20.8218 24.545 20.2967 25.0701C19.7716 25.5952 19.4766 26.3074 19.4766 27.05V33.5775C19.4766 34.3201 19.7716 35.0323 20.2967 35.5574C20.8218 36.0825 21.534 36.3775 22.2766 36.3775H33.4678C35.0122 36.3775 36.2634 35.1263 36.2634 33.5775V27.0456C36.2634 25.5012 35.0122 24.25 33.4678 24.25Z",
    fill: "#FCC21B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8653 41.9678C41.8653 49.6941 35.6003 55.9591 27.8741 55.9591C20.1478 55.9591 13.8828 49.6984 13.8828 41.9678C13.8828 34.2372 20.1478 27.9766 27.8741 27.9766C35.6047 27.9766 41.8653 34.2416 41.8653 41.9678Z",
    fill: "#FCC21B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4935 38.5647C18.3098 38.5647 18.126 38.5297 17.951 38.4509C17.2773 38.1622 16.9535 37.379 17.216 36.7009C17.2204 36.6922 17.2248 36.679 17.2248 36.6703C17.2291 36.6484 17.2335 36.6528 17.2423 36.6353C18.4804 33.6865 21.0748 31.5078 24.1898 30.7859C24.3429 30.7509 24.5048 30.8253 24.5748 30.9697C24.6448 31.114 24.6054 31.289 24.4785 31.3897C22.4354 33.0128 20.8035 35.2003 19.7623 37.7203C19.7623 37.7247 19.7579 37.729 19.7579 37.729C19.7579 37.729 19.7579 37.7334 19.7535 37.7334C19.6091 38.0703 19.3423 38.3328 19.001 38.464C18.8391 38.534 18.6641 38.5647 18.4935 38.5647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5106 27.0462H22.315L8.32812 0H19.5194L33.5106 27.0462Z",
    fill: "#006CA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1556 39.1184L26.455 38.7465V45.8821H25.4531C25.3438 45.8821 25.2606 45.9696 25.2606 46.0746V48.5159C25.2606 48.6209 25.3438 48.7084 25.4531 48.7084H30.6375C30.7425 48.7084 30.83 48.6209 30.83 48.5159V46.0746C30.83 45.9696 30.7425 45.8821 30.6375 45.8821H29.6356V35.4303C29.6356 35.3734 29.6094 35.3165 29.5612 35.2815C29.5388 35.2635 29.5127 35.2507 29.4847 35.2439C29.4567 35.2371 29.4276 35.2365 29.3994 35.2421L25.0594 36.174C24.9719 36.1959 24.9062 36.2703 24.9062 36.3621V38.9346C24.9062 38.9915 24.9325 39.0528 24.9806 39.0878C25.0375 39.1228 25.0987 39.1315 25.1556 39.1184Z",
    fill: "#F79329"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2146_3394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportRankFirst);
export default __webpack_public_path__ + "static/media/report_rank_first.1f5c8bb2f3962df1ab452591060d7bd6.svg";
export { ForwardRef as ReactComponent };